import { render } from "./LmsCatalogView.vue?vue&type=template&id=562eb80a&scoped=true&ts=true"
import script from "./LmsCatalogView.vue?vue&type=script&lang=ts"
export * from "./LmsCatalogView.vue?vue&type=script&lang=ts"

import "./LmsCatalogView.vue?vue&type=style&index=0&id=562eb80a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-562eb80a"]])

export default __exports__